import { get, post, serialize } from '../httpClient';

export const commentsAPI = {
  query: params => get('/api/comments/query', params),
  send: body => post('/api/comments/send', serialize(body)),
  update: body => post('/api/comments/update', serialize(body)),
  delete: body => post('/api/comments/delete', serialize(body)),
  addLike: body => post('/api/comments/add-like', serialize(body)),
  addDislike: body => post('/api/comments/add-dislike', serialize(body)),
  pin: body => post('/api/comments/pin', serialize(body)),
};